
























































































































































import { Vue, Component } from "vue-property-decorator";
import { SigninModel, AuthType } from "../model/system";
import { Form, Field, Toast, Checkbox } from "vant";
import UserService from "@/service/UserService";
import { loadLanguageAsync } from "@/lang/index";
import { isOfw } from "@/utils/utils";

@Component({
  components: {
    [Form.name]: Form,
    [Field.name]: Field,
    [Checkbox.name]: Checkbox,
  },
})
export default class Login extends Vue {
  isCaptcha = false;
  get isLchApp() {
    return !isOfw();
  }
  isAgreePolicy = false;
  disabledAgree = false;
  isShowPolicyWarning = false;
  showPolicy = false;
  model: SigninModel = {
    // UserAct: "cls@lc.com",
    // UserPwd: "cls@lc.com",
    UserAct: "",
    UserPwd: "",
    IsRemember: true,
    DeviceInfo: "App",
    ValidCode: "",
    LoginMode: AuthType.AccountAuth,
  };
  pageHeight = window.outerHeight || window.innerHeight;
  mounted() {
    // if(localStorage.getItem("firstOpenApp") !== "Y") {
    //   this.showPolicy = true
    // }else{
    //   this.isAgreePolicy = true;
    //   this.disabledAgree = true;
    // };
    this.pageHeight = window.outerHeight || window.innerHeight;
    if (window.localStorage.lange) {
      this.toggleFlag = window.localStorage.lange;
    }
  }
  // goPolicy(path: string) {
  //   this.$router.push({path});
  // }
  // subPolicy(){
  //   localStorage.setItem("firstOpenApp", "Y");
  //   this.isAgreePolicy = true;
  //   this.showPolicy = false;
  // }

  toggleFlag: string = "cn";
  showLangItem = false;
  toggle(value: string) {
    let __self = this;
    __self.toggleFlag = value;
    window.localStorage.lange = value;
    loadLanguageAsync(value).then(() => {
      __self.$i18n.locale = window.localStorage.lange;
    });
    this.showLangItem = false;
  }

  deviceInfo() {
    if (localStorage.deviceInfo) {
      return JSON.parse(localStorage.deviceInfo);
    }
  }

  login(isArgeePolicy?: boolean) {
    // if (isArgeePolicy && isArgeePolicy === true) {
    //   this.isAgreePolicy = true;
    // }
    if (!this.isAgreePolicy) {
      this.$toast({
        message: "请您同意我们的《服务协议》和《隐私政策》",
      });
      // this.isShowPolicyWarning = true;
      return;
    }
    const model = this.model;
    const data: SigninModel = {
      UserAct: model.UserAct,
      UserPwd: model.UserPwd,
      IsRemember: model.IsRemember,
      DeviceInfo: model.DeviceInfo,
      DeviceCode: "",
      AppKey: "",
      ValidCode: model.ValidCode,
      LoginCodes: "initialize",
      LoginMode: AuthType.AccountAuth,
    };
    if (this.isCaptcha) {
      data.LoginMode = AuthType.DynamicAuth;
      data.UserPwd = this.UserCode;

      if (data.ValidCode == "") {
        return this.$root.$toast(this.$t("share.fail.VerificationCode"));
      }
      if (data.UserPwd == "") {
        return this.$root.$toast(this.$t("share.fail.DynamicCode"));
      }
    }

    // eslint-disable-next-line
    const that = this;
    const $router = this.$router;

    this.$store.dispatch("signIn", data).then(function(json) {
      if (json.isSucc && that.profile != null) {
        // if (json.isSucc) {
        // $router.push("/");
        location.href = "/";
      } else {
        Toast.fail(json.message);
      }
    });
  }
  UserCode = "";
  // dlogin() {
  //   let __self = this;
  //   if (this.model.ValidCode == "") {
  //     return this.$root.$toast(this.$t("share.fail.VerificationCode"));
  //   }
  //   if (this.model.UserPwd == "") {
  //     return this.$root.$toast(this.$t("share.fail.DynamicCode"));
  //   }
  //   this.login();
  // }

  checkLoginType() {
    this.isCaptcha = !this.isCaptcha;
  }
  checkImageUrl = `/api/side/common/ValidCode?${Math.random()}`;
  ReloadImage() {
    var __self = this;
    __self.checkImageUrl = `/api/side/common/ValidCode?${Math.random()}`;
  }
  value = {} as any;

  judgeCode = true;
  textCode = "login_fasongyanzhengma";
  setInterval = 0;
  sendCode() {
    let __self = this;
    let model = this.model;
    if (model.UserAct == "") {
      return this.$root.$toast(__self.$t("share.fail.Account"));
    }
    if (model.ValidCode == "") {
      return this.$root.$toast(__self.$t("share.fail.VerificationCode"));
    }
    if (!__self.judgeCode) {
      return;
    }
    __self.judgeCode = false;
    let $time = 60;

    function run() {
      __self.textCode = __self.$t("system.Sent") + "(" + --$time + ")";
      if ($time <= 0) {
        clearInterval(__self.setInterval);
        __self.textCode = "login_fasongyanzhengma";
        __self.judgeCode = true;
      } else {
        __self.judgeCode = false;
      }
    }
    UserService.sendValidCode(model).then(json => {
      if (json.isSucc) {
        __self.setInterval = setInterval(run, 1000);
        this.$root.$notify(json.message as string);
      } else {
        this.$root.$toast.fail(json.message as string);
      }
      __self.judgeCode = true;
    });
  }

  ToReset() {
    let __self = this;
    __self.$router.push({
      path: "/reset",
    });
  }

  // srcollToView() {
  //   setTimeout(() => {
  //     document.getElementById("srcollToView")?.scrollIntoView();
  //   }, 100);
  // }
}
